import { Box, Button, Group, Paper, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";

const COOKIE_CONSENT_KEY = "cookie-consent";

export const CookieBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (consent === null) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Box
      pos="fixed"
      bottom={0}
      left={0}
      right={0}
      p="md"
      style={{
        zIndex: 1000,
      }}
    >
      <Paper shadow="lg" withBorder p="lg" radius="sm" mx="auto" maw={900}>
        <Group justify="space-between" align="center" wrap="wrap" gap="md">
          <Text w="100%" size="xs" style={{ flex: 1, minWidth: "250px" }}>
            We use cookies to enhance your browsing experience and analyze our
            traffic. By clicking "Accept", you consent to our use of cookies.
          </Text>

          <Group w={{ base: "100%", sm: "auto" }} gap="sm" wrap="nowrap">
            <Button
              fullWidth
              variant="flat-square-light"
              onClick={handleDecline}
              size="xs"
            >
              Decline
            </Button>

            <Button
              fullWidth
              variant="flat-square"
              onClick={handleAccept}
              size="xs"
            >
              Accept
            </Button>
          </Group>
        </Group>
      </Paper>
    </Box>
  );
};
